import { render, staticRenderFns } from "./thaiExtraParam.vue?vue&type=template&id=32465f1d&scoped=true"
import script from "./thaiExtraParam.vue?vue&type=script&lang=ts"
export * from "./thaiExtraParam.vue?vue&type=script&lang=ts"
import style0 from "./thaiExtraParam.vue?vue&type=style&index=0&id=32465f1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32465f1d",
  null
  
)

export default component.exports